export default __webpack_public_path__ + "static/bgImageSBMd-166c8f3850741f8c943a929ac318bf43.png";